import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ELearningRoutingModule } from './e-learning-routing.module';


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    ELearningRoutingModule
  ]
})
export class ELearningModule { }
